import { contact as contactFields } from "../../msp/AddMspForm/config";

export const editFormFields = contactFields
  .filter((field) =>
    [
      "first_name",
      "last_name",
      "corporate_email",
      "designation",
      "job_title",
      "mobile_phone",
      "work_phone_no",
      "street_address",
      "country_id",
      "state_id",
      "city_id",
      "postal_code",
    ].includes(field.name)
  )
  .map((field) => ({
    ...field,
    options:
      field.name.includes("country_id") ||
        field.name.includes("state_id") ||
        field.name.includes("city_id")
        ? []
        : field.options,
    asyncOptions: false,
  }));
